/*
 * Product-card image swipe (touch devices only).
 *
 * On desktop, hovering a product card cross-fades to the second image
 * (base.css: `.media.media--hover-effect > img + img { opacity: 0 }`, revealed
 * by a `(hover: hover)` :hover rule). Touch devices get no hover, so the second
 * image is never seen. This adds the same reveal on a horizontal swipe: swipe
 * left shows the second image, swipe right returns to the first -- by toggling a
 * `.media--show-second` class the CSS keys off (component-card.css).
 *
 * Uses event delegation on document so cards added later (AJAX filtering,
 * infinite scroll, quick-add) work without re-binding. A real swipe suppresses
 * the card's overlay-link navigation so the swipe doesn't also open the product;
 * a plain tap still navigates. Gated to `(hover: none)` so it never touches the
 * desktop hover behaviour. Client feedback Aug 2026.
 *
 * Collection grid only. Carousel cards (product-recommendations,
 * popular-products, products-tabs, recently-viewed etc.) don't carry
 * .media--swipe -- product-card.liquid's enable_swipe param, which adds that
 * class, is intentionally not set there -- so they never reach this handler.
 * Tried extending this to carousels (Aug 2026) with a long-swipe-only
 * threshold so it wouldn't fight Swiper's own swipe-to-advance; real-world
 * testing showed no distance/speed threshold reliably tells "advance the
 * carousel" from "reveal the image" apart (ordinary decisive swipes are just
 * as long as deliberate ones), so touch reveal was dropped there. Carousels
 * still eager-load the second image (product-card.liquid's
 * eager_second_image param) so desktop hover never shows a blank frame.
 */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;

  var SWIPE_MIN = 30; // px of horizontal travel to count as a swipe
  var startX = 0;
  var startY = 0;
  var media = null;
  var card = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      media = null;
      card = e.target.closest ? e.target.closest('.card-wrapper') : null;
      if (!card) return;
      // .media--swipe is only set on the collection-grid cards (product-card.liquid
      // enable_swipe), so the swipe never activates in carousels/search/etc. The
      // second image there is eager-loaded server-side, so no JS preload is needed.
      var m = card.querySelector('.media--swipe');
      if (!m) return;
      // Need at least two stacked images to swap between.
      if (m.querySelectorAll(':scope > img, :scope > picture').length < 2) return;
      media = m;

      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!media) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      var m = media;
      var c = card;
      media = null;
      card = null;

      // Horizontal intent, past the threshold (ignore vertical scrolls).
      if (Math.abs(dx) <= Math.abs(dy) || Math.abs(dx) < SWIPE_MIN) return;

      if (dx < 0) m.classList.add('media--show-second');
      else m.classList.remove('media--show-second');

      // Swallow the navigation click the swipe would otherwise trigger on the
      // card's overlay link, without blocking a normal tap.
      var overlay = c && c.querySelector('.card-wrapper__link--overlay');
      if (overlay) {
        var suppress = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        overlay.addEventListener('click', suppress, { capture: true, once: true });
        setTimeout(function () {
          overlay.removeEventListener('click', suppress, { capture: true });
        }, 500);
      }
    },
    { passive: true }
  );
})();
